
import { Vue, Component } from 'vue-property-decorator';
import TopSection from '@/features/shipment/components/shipmentSuccess/TopSection.vue';
import Instructions from '@/features/shipment/components/shipmentSuccess/instructions/index.vue';
import { scrollToInPage } from '@/features/common/helpers';

@Component({
  components: {
    TopSection,
    Instructions,
  },
})
export default class ShipmentSuccess extends Vue {
  // eslint-disable-next-line class-methods-use-this
  mounted(): void {
    scrollToInPage();
  }
}
